import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import LinkBranded from 'src/elements/links/Link.branded';
import { PricingDisplayMode } from 'src/elements/pricing/PricingBanner';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';
import PricingDetailsTable from './PricingDetailsTable';
import { pricingPlanDetailsTablesData } from './PricingPlanDetailsTablesData';

export const TableListContainer = styled.div`
  max-width: 1440px !important;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 3.25rem 4.8rem;
  display: grid;
  grid-row-gap: 2rem;

  > a {
    max-width: 280px;
    width: 100%;
    margin: 2rem auto 0;
    color: #141921;
  }

  @media screen and (max-width: ${layout.sm}) {
    max-width: 100vw !important;
    padding-left: 0;
    padding-right: 0;
  }
`

interface PricingPlanDetailsTableListProps {
  activePriceMode: PricingDisplayMode;
}

interface PricingPlansProps {
  pricing: {
    pricingItems: {
      id: string;
      title: string;
      annualPrice: number;
      monthlyPrice: number
    }[]
  }
}

const PricingPlanDetailsTableList = ({ activePriceMode }: PricingPlanDetailsTableListProps): JSX.Element => {
  const pricingPlans: PricingPlansProps = useStaticQuery(graphql`{
    pricing: contentfulPricing(contentful_id: {eq: "3MVlrgM0V8QHZaywYDSrrU"}) {
      pricingItems {
        id
        title
        annualPrice
        monthlyPrice
      }
    }
  }
  `)

  const communityPrices = pricingPlans.pricing.pricingItems.find(data => data.title === 'The Community Plan');
  const businessPrices = pricingPlans.pricing.pricingItems.find(data => data.title === 'The Business Plan');

  return (
    <TableListContainer>
      {
        pricingPlanDetailsTablesData.map((table, index) => (
          <PricingDetailsTable
            activePriceMode={activePriceMode}
            key={index}
            prices={{
              community: {
                annual: communityPrices.annualPrice,
                monthly: communityPrices.monthlyPrice
              },
              business: {
                annual: businessPrices.annualPrice,
                monthly: businessPrices.monthlyPrice
              }
            }}
            {...table}
          />
        ))
      }
      <LinkBranded
        url="https://new.mn.co/?plan=free-trial"
        text="Start Your Free Trial"
        backgroundColor={palette.pricingLightGreen}
      />
    </TableListContainer>
  )
}

export default PricingPlanDetailsTableList;
